/** Matches CMS `Locale` enum values; kept here to avoid circular imports with CMSStore. */
export type PublicCmsLocaleString = 'da_DK' | 'en_GB';

const STORED_PUBLIC_LANG_KEY = 'minkonto.publicLang';

export function parsePublicLangFromSearch(search: string): PublicCmsLocaleString | null {
  const params = new URLSearchParams(search);
  const lang = params.get('lang');
  if (lang === 'da') return 'da_DK';
  if (lang === 'en') return 'en_GB';
  return null;
}

export function getStoredPublicCmsLocaleString(): PublicCmsLocaleString | null {
  const raw = localStorage?.getItem(STORED_PUBLIC_LANG_KEY);
  if (raw === 'da') return 'da_DK';
  if (raw === 'en') return 'en_GB';
  return null;
}

export function setStoredPublicLang(lang: 'da' | 'en'): void {
  localStorage?.setItem(STORED_PUBLIC_LANG_KEY, lang);
}

export function mergePublicLangSearch(currentSearch: string, lang: 'da' | 'en'): string {
  const params = new URLSearchParams(currentSearch);
  params.set('lang', lang);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function assignPublicLangAndReload(lang: 'da' | 'en'): void {
  setStoredPublicLang(lang);
  const search = mergePublicLangSearch(window.location.search, lang);
  const next = `${window.location.pathname}${search}${window.location.hash}`;
  window.location.assign(next);
}
